import { useLensPinPreferences } from '~/hooks/apis/reporting/useLensPinPreferences';

/** The rail, landing and library share one account's shortcuts and receive the same updates. */
export function useLensPins() {
  const { query, setIds } = useLensPinPreferences();
  return [
    query.data?.lensIds ?? [],
    setIds,
    {
      lenses: query.data?.lenses ?? [],
      isLoading: query.isLoading,
      isError: query.isError,
      retry: query.refetch,
    },
  ] as const;
}
